import { Navigate } from 'react-router'
import { useFormConfirmed } from 'shared/hooks/useFormConfirmed'

import { FormDeposit, SuccessData } from 'modules/pools/ui/FormDeposit'
import { SentTransaction } from 'modules/pools/ui/SentTransaction'
import { NarrowWrapper } from 'shared/ui/layout/NarrowWrapper'

import { createRoute } from 'modules/router/utils/createRoute'
import { FormDepositWarning } from 'modules/pools/ui/FormDepositWarning'

function RouteDeposit() {
  const { pathname, isConfirmed, successData, confirmForm } =
    useFormConfirmed<SuccessData>()

  if (isConfirmed) {
    if (!successData) return <Navigate replace to={pathname} />
    return (
      <SentTransaction
        txHash={successData.tx.hash}
        transactionType="Deposit"
        amountToDisplay={successData.formValues.amount}
        amountToken={successData.formValues.depositedAsset}
        warning={<FormDepositWarning />}
      />
    )
  }

  return (
    <NarrowWrapper>
      <FormDeposit onSuccess={confirmForm} />
    </NarrowWrapper>
  )
}

export const routeDeposit = createRoute({
  headerTitle: 'Deposit',
  layoutType: 'narrow-extended',
  component: RouteDeposit,
  checkConnect: true,
})
